import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import PropTypes from 'prop-types'

const bem = new BEMHelper('AccountDetailsSection')

const propTypes = {
    info: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    className: PropTypes.string,
    children: PropTypes.node
}

function AccountDetailsSection(props) {
    const { info, className, children } = props

    const filteredInfo = Array.isArray(info) ? info.filter((item) => item) : info

    return (
        <div className={bem(null, null, className)}>
            {Array.isArray(info) ? (
                <ul className={bem('infoList')}>
                    {filteredInfo.map((infoItem, index) =>
                        infoItem ? (
                            <li key={index} className={bem('infoItem', filteredInfo.length > 1 ? 'withBullets' : null)}>
                                {infoItem}
                            </li>
                        ) : null
                    )}
                </ul>
            ) : (
                <div className={bem('info')}>{info}</div>
            )}
            {children ? <div className={bem('actions')}>{children}</div> : null}
        </div>
    )
}

AccountDetailsSection.propTypes = propTypes

export default AccountDetailsSection
